// @ts-nocheck
import { toJalaali } from "jalaali-js";
import AdminOrdersContext from "../../../context/order/AdminOrdersContext.tsx";
import { useContext } from "react";
import UserContext from "../../../context/order/UserContext";
// datepicker
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import { addCommas } from "@persian-tools/persian-tools";
import useWindowSize from "../../../hooks/useWindowSize";
import { FaEye } from "react-icons/fa";
export default function CompletedOrderCard({ order, index }) {
  const { selectOrder } = useContext(AdminOrdersContext);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  let { width } = useWindowSize();
  function timeMaker(time) {
    try {
      let perTm = toJalaali(new Date(parseInt(mtm) * 1000));
      return `${perTm.jy}/${perTm.jm < 10 ? 0 : ""}${perTm.jm}/${
        perTm.jd < 10 ? 0 : ""
      }${perTm.jd}`;
    } catch (ex) {
      return "";
    }
  }
  const timestampToDate = time => {
    const a = time * 1000;
    const date = new DateObject({ date: a, calendar: persian });
    const b = new Date(a);
    return date.format();
  };

  return (
    <div className="order-card mx-auto">
      <div className="order-card-body">
        <div
          className={`order-card-header ${index % 2 == 0 ? "even" : "odd"}`}
          onClick={() => {
            selectOrder(order, true);
          }}
        >
          <div
            className={`text-center col-lg-1 col-sm-2 col-4 ${width < 992 &&
              "borderBottom"}`}
          >
            <div className="title">شماره</div>
            <div className="pb-2"> {order.id}</div>
          </div>
          <div
            className={`text-center col-xxl-1 col-md-2 col-sm-3 col-4 ${width <
              992 && "borderBottom"}`}
          >
            <div className="title">تاریخ</div>
            <div className=" pb-2">{timestampToDate(order.mtm)}</div>
          </div>
          <div
            className={`text-center col-xxl-1 col-lg-2 col-sm-3 col-4 ${width <
              992 && "borderBottom"}`}
          >
            <div className="title">فروشگاه</div>
            <div className=" pb-2">
              {/* {order.supplier_info[0].title != ""
                ? order.supplier_info[0].title
                : "--"} */}
              {order.supplier_info.title != ""
                ? order.supplier_info.title
                : "--"}
            </div>
          </div>
          {!customerOrders && (
            <div
              className={`text-center col-xxl-2 col-xl-2 col-md-3 col-sm-4 col-7 ${width <
                992 && "borderBottom"}`}
            >
              <div className="title">نام و نام خانوادگی</div>
              <div className=" pb-2">
                {order.user_info.fname != "" || order.user_info.lname != "" ? (
                  <>
                    {order.user_info.fname != "" && order.user_info.fname}{" "}
                    {order.user_info.lname != "" && order.user_info.lname}
                  </>
                ) : (
                  "--"
                )}
              </div>
            </div>
          )}
          <div
            className={`text-center col-xl-1 col-md-2 col-sm-3 col-5 ${width <
              992 && "borderBottom"} ${customerOrders &&
              width < 768 &&
              "borderBottom"} ${!customerOrders &&
              width < 768 &&
              width > 576 &&
              "border-0"} ${!customerOrders && width < 576 && "borderBottom"} `}
          >
            <div className="title">تعداد کالا</div>
            <div className=" pb-2">{order.items.length}</div>
          </div>
          <div
            className={`text-center col-lg-2 col-md-4 col-sm-3 col-6 ${width <
              992 &&
              width > 992 &&
              "borderBottom"} ${!customerOrders &&
              width < 576 &&
              "borderBottom"}`}
          >
            <div className="title">مبلغ</div>
            <div className="pb-2">
              {" "}
              {addCommas(order.total_price - order.total_discount)}
            </div>
          </div>
          <div
            className={`text-center col-xl-2 col-lg-6 col-md-4 col-sm-4 col-6 
           
            `}
          >
            <div className="title"> مشاهده جرئیات</div>
            <div className="pb-2 mx-auto">
              <button
                className="btn"
                onClick={() => {
                  selectOrder(order, true);
                }}
              >
                <FaEye
                  style={{ color: index % 2 == 0 ? "white" : "#fe5443" }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
